const initState = {
  complaintLoader: false,
  issues: [],
  institutes: [],
  hsInstitutes: [],
  states: [],
  schoolStates: [],
  cities: [],
  counties: [],
  collegeInstitutes: [],
  athleteData: null,
  athleteSchool: null,
  lastDocument: null,
  hasMoreDocument: true,
};

const athleteReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_ATHLETE_ISSUES":
      return {
        ...state,
        issues: action.payload.data,
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_ATHLETE_ISSUES_MORE":
      return {
        ...state,
        issues: [...state.issues, ...action.payload.data],
        hasMoreDocument: action.payload.hasMoreDocument,
        lastDocument: action.payload.lastDocument,
      };
    case "GET_INSTITUTES":
      return {
        ...state,
        institutes: action.payload,
      };
    case "GET_HIGH_SCHOOL_INSTITUTES":
      return {
        ...state,
        hsInstitutes: action.payload,
      };
    case "GET_STATES":
      return {
        ...state,
        states: action.payload,
      };
    case "GET_SCHOOL_STATES":
      return {
        ...state,
        schoolStates: action.payload,
      };
    case "GET_CITY_BY_STATE":
      return {
        ...state,
        cities: action.payload,
      };
    case "GET_COUNTY_BY_STATE":
      return {
        ...state,
        counties: action.payload,
      };
    case "NEW_COLLEGE_UNIVERSITIES":
      return {
        ...state,
        collegeInstitutes: action.payload,
      };
    case "GENERATE_COMPLAINT":
      return {
        ...state,
        complaintLoader: true,
      };
    case "GENERATE_COMPLAINT_END":
      return {
        ...state,
        complaintLoader: false,
      };
    case "ATHLETE_DATA_RECEIVED":
      return {
        ...state,
        athleteData: action.payload,
      };
    case "FETCH_ATHLETE_SCHOOL_SUCCESS":
      return {
        ...state,
        athleteSchool: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default athleteReducer;
